import { exception } from 'circe/logger';
import { AUTHORITIES } from 'domain/fuse/auth/constants';
import { SELECTED_PROFILE_LOCAL_KEY, PROFILES_CONFIG, PROFILE_STATUS } from './constants';

export const updateSelectedProfileStorage = (profile) => {
  localStorage.setItem(SELECTED_PROFILE_LOCAL_KEY, JSON.stringify(profile));
};

export const getSelectedProfileFromStorage = () => {
  const profile = localStorage.getItem(SELECTED_PROFILE_LOCAL_KEY);
  return JSON.parse(profile) || {};
};

export const getIfSelectedProfileIsCourier = () => {
  const profile = JSON.parse(localStorage.getItem(SELECTED_PROFILE_LOCAL_KEY));
  return (
    profile.role.concat('_', profile?.accountInfo?.accountType) == AUTHORITIES.ACCOUNT_ADMIN_COURIER
  );
};

/**
 * Get the profiles that can be added PER ACCOUNT
 * @param {*} profiles
 */
export const getPossiblePorfilesAndActions = (profiles, currentUserRole) => {
  const output = {};

  Object.keys(PROFILES_CONFIG).forEach((key) => {
    profiles.forEach((profile) => {
      const configOutput = { ...PROFILES_CONFIG[key] };
      const { role } = profile;
      const canGrant = canHaveProfileAction(profile, 'grant', role, currentUserRole);
      const canRevoke = canHaveProfileAction(profile, 'revoke', role, currentUserRole);
      const canApporve = canHaveProfileAction(profile, 'approve', role, currentUserRole);

      if (!canGrant) delete configOutput.grant;
      if (!canRevoke) delete configOutput.revoke;
      if (!canApporve) delete configOutput.approve;
      const haveRole = canGrant || canRevoke || canApporve;
      if (haveRole) {
        output[key] = configOutput;
        output[key].key = key;
      }
    });
  });
  return output;
};
export const getProfilesAction = (profiles, currentUserRole) => {
  const profilesWithActions = getPossiblePorfilesAndActions(profiles, currentUserRole);

  return Object.keys(profilesWithActions).map((key) => {
    const currrentAction = profilesWithActions[key];
    const { grant, revoke, approve } = currrentAction;
    return {
      ...currrentAction,
      allowed: [grant, revoke, approve].filter(Boolean),
    };
  });
};

/**
 * Check if the user does have a specifc role
 * @param {*} profiles
 * @param {*} role
 */
export const doesHaveRole = (profiles, role) =>
  profiles.filter((profile) => profile.role === role).length > 0;

export const canHaveProfileAction = (profile, action, profileType, currentUserRole) => {
  const { status } = profile;
  try {
    action === 'revoke' &&
      console.log(
        'User with profile 2',
        profile.profileId,
        'Can have an action ',
        action,
        'on this profile type ',
        profileType,
      );

    if (!PROFILES_CONFIG[profileType] || !PROFILES_CONFIG[profileType][action]) return false;
    action === 'revoke' &&
      console.log(
        'User with profile 3',
        profile.profileId,
        'Can have an action ',
        action,
        'on this profile type ',
        profileType,
      );

    if (PROFILES_CONFIG[profileType][action].authorities.includes(currentUserRole)) {
      switch (profileType) {
        case 'revoke': {
        }
        case 'approve': {
        }
        case 'grant': {
        }
      }
      const doesUserHaveIt = PROFILES_CONFIG[profileType][action].statuses.includes(status);
      if (doesUserHaveIt) return false;
      action === 'revoke' &&
        console.log(
          'User with profile 4',
          profile.profileId,
          'Can have an action ',
          action,
          'on this profile type ',
          profileType,
        );

      if (
        !doesUserHaveIt &&
        PROFILES_CONFIG[profileType][action].statuses.includes(PROFILE_STATUS.EMPTY)
      ) {
        action === 'revoke' &&
          console.log(
            'User with profile ',
            profile.profileId,
            'Can have an action ',
            action,
            'on this profile type ',
            profileType,
          );
        return true; // Currrent available and already have it
      }
    }
    return false;
  } catch (e) {
    exception(e, { action, profileType, currentUserRole });
    return false;
  }
};
